/**
 * This client was automatically generated by RudderTyper. ** Do Not Edit **
 */

import type {
  RudderAnalytics,
  RudderAnalyticsPreloader,
  ApiOptions,
  ApiObject,
} from '@rudderstack/analytics-js'
/**
 * The analytics instance should be available via window.rudderanalytics.
 * You can install it by following instructions at: https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/installation/
 */
declare global {
  interface Window {
    rudderanalytics: RudderAnalytics | RudderAnalyticsPreloader | undefined
  }
}

type apiCallback = (data?: any) => void

export type Signupsource_String =
  | 'organic'
  | 'invite'
  | 'databricks_partner'
  | 'referral'

export type Action_String = 'created' | 'updated'

export type Resourcecategory_String =
  | 'event_stream'
  | 'reverse_etl'
  | 'tracking_plan'
  | 'profiles'

export type Channeltype_String = 'email' | 'slack' | 'webhook'

export type Audiencetype_String = 'data_graph' | 'cohort' | 'legacy'

export type Conditionoperator_String = 'equal' | 'notEqual' | 'in'

export type Syncstatus_String = 'success' | 'failed' | 'partial'

export type Syncfrequency_String = 'manual' | 'hourly' | 'daily' | 'custom'

export type Blockingmode_String = 'block' | 'sample' | 'allow'

export type Eventtype_String =
  | 'track'
  | 'identify'
  | 'page'
  | 'screen'
  | 'group'

export type Propertytype_String =
  | 'string'
  | 'integer'
  | 'boolean'
  | 'array'
  | 'object'

export type Abandonmentreason_String =
  | 'closed_drawer'
  | 'navigated_away'
  | 'session_timeout'
  | 'payment_declined'

export type Currency_String = 'usd'

export type Paymentmethodtype_String =
  | 'credit_card'
  | 'debit_card'
  | 'bank_transfer'

export type Errortype_String =
  | 'payment_declined'
  | '3ds_failed'
  | 'network_error'
  | 'validation_error'
  | 'stripe_error'

export type Stepwherefailed_String =
  | 'payment_method'
  | '3ds_authentication'
  | 'charge_confirmation'

export type Connectionmode_String = 'cloud_mode' | 'device_mode' | 'hybrid'

export type Destinationcategory_String = 'warehouse' | 'cloud'

export type Sourcecategory_String =
  | 'event_stream'
  | 'cloud_extract'
  | 'warehouse_action'
  | 'singer'

export type Skipreason_String = 'high_cardinality'

export type Warehousetype_String =
  | 'snowflake'
  | 'redshift'
  | 'databricks'
  | 'bigquery'

export type Modeltype_String = 'entity' | 'event'

export type Relationshiptype_String =
  | 'one-to-one'
  | 'one-to-many'
  | 'many-to-one'

export type Featurename_String =
  | 'profiles'
  | 'audiences'
  | 'data_graph'
  | 'data_catalog'
  | 'bot_detection'
  | 'event_blocking'
  | 'service_access_tokens'
  | 'scim'
  | 'data_residency'

export type Requiredplan_String = 'growth' | 'enterprise'

export type Sectionname_String = 'foundation' | 'data_quality' | 'activation'

export type Timerange_String = '1h' | '6h' | '24h' | '7d' | '30d' | 'custom'

export type Resourcestatus_String = 'healthy' | 'warning' | 'error'

export type Integrationtype_String = 'source' | 'destination'

export type Validationstatus_String = 'passed' | 'failed' | 'skipped'

export type Changetype_String =
  | 'upgrade'
  | 'downgrade'
  | 'trial_started'
  | 'trial_converted'
  | 'trial_expired'
  | 'cancellation'

export type Limittype_String =
  | 'event_volume'
  | 'cloud_extract_sources'
  | 'warehouse_actions'
  | 'transformations'
  | 'tracking_plans'
  | 'event_blocking'
  | 'team_members'
  | 'workspaces'
  | 'retl_connections'

export type Threshold_Integer = 80 | 90 | 95

export type Gitprovider_String = 'github' | 'gitlab' | 'bitbucket'

export type Creationflow_String = 'ide' | 'copilot' | 'git'

export type Scheduletype_String = 'basic' | 'cron' | 'manual'

export type Triggertype_String = 'manual' | 'scheduled'

export type Dataorigin_String = 'sql_model' | 'audience' | 'direct_table'

export type Tokenscope_String = 'organization' | 'workspace'

export type Violationtype_String =
  | 'unplanned_event'
  | 'missing_property'
  | 'type_mismatch'
  | 'unknown_property'

export type Destinationmode_String = 'cloud_mode' | 'device_mode'

export type Language_String = 'javascript' | 'python'

export type Templatetype_String = 'custom' | 'template'

export type Testresult_String = 'success' | 'error'

export type Activationstatus_String =
  | 'no_source'
  | 'source_only'
  | 'connection_created'
  | 'data_flowing'
  | 'checklist_complete'

export type Outcome_String = 'downgraded_to_free' | 'converted_during_grace'

export type Trigger_String = 'auto_signup' | 'opt_in_free' | 'admin_extension'

export type Warningphase_String = 'early' | 'mid' | 'urgent'

export type Warningtype_String =
  | 'badge_color_change'
  | 'expiry_banner'
  | 'expiry_modal'
  | 'checklist_slot_nudge'

export type Ctalocation_String =
  | 'sidebar_badge'
  | 'event_usage_alert'
  | 'resource_limit_banner'
  | 'feature_gate'
  | 'plans_page_cta'
  | 'workspace_overlay'
  | 'trial_expiry_banner'
  | 'checklist_header_slot'

export type Destinationpage_String =
  | 'plans_page'
  | 'subscription_drawer'
  | 'contact_sales_modal'
  | 'trial_start'

export type Completionstatus_String = 'completed' | 'skipped' | 'partial'

export type Authmethod_String = 'email_password' | 'google' | 'sso'

export type Signupmethod_String = 'email_password' | 'google' | 'sso' | 'invite'

export type Workspacepurpose_String = 'production' | 'development' | 'staging'

export type Pagecategory_String =
  | 'collect'
  | 'unify'
  | 'activate'
  | 'govern'
  | 'monitor'
  | 'settings'
  | 'onboarding'
  | 'auth'
  | 'home'
  | 'directory'
  | 'unknown'

export type Onboardingquestionsstatus_String =
  | 'completed'
  | 'skipped'
  | 'pending'

export interface AccountCreated {
  isTrial: boolean
  organizationId: string
  planName: CustomTypeDefs['Plan_name_type']
  region: CustomTypeDefs['Region_type']
  signupSource: Signupsource_String
}

export interface AlertConfigured {
  action: Action_String
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  alertName: string
  resourceCategory: Resourcecategory_String
  resourceId: string
  resourceType: string
}

export interface AlertToggled {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  alertName: string
  channelType: Channeltype_String
  isEnabled: boolean
  resourceId: string
}

export interface AudienceCreated {
  audienceId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  audienceName: string
  audienceType: Audiencetype_String
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  expressionComplexity?: number
  profilesProjectId?: string
  rootModel?: string
}

export interface AudienceDeleted {
  audienceId: string
  dataGraphId: string
}

export interface AudienceDetailViewed {
  audienceId: string
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  syncCount: number
}

export interface AudienceExpressionEdited {
  audienceId: string
  audienceType: Audiencetype_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  conditionCount: number
  dataGraphId: string
  usesAggregates: boolean
  usesRelationships: boolean
  usesTimeWindows: boolean
}

export interface AudienceListViewed {
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalAudiencesCount: number
}

export interface AudiencePreviewSubmitted {
  audienceId: string
  dataGraphId: string
}

export interface AudienceRenamed {
  audienceId: string
  dataGraphId: string
}

export interface AudienceSuggestionUsed {
  audienceId?: string
  columnName: string
  conditionOperator: Conditionoperator_String
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  suggestionsCount?: number
  valueFromSuggestion: boolean
}

export interface AudienceSyncCompleted {
  audienceId: string
  destinationId: string
  destinationType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  durationSeconds: number
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  recordsSyncedCount: number
  syncStatus: Syncstatus_String
  workspaceId: string
}

export interface AudienceSyncConfigured {
  audienceId: string
  audienceType: Audiencetype_String
  dataGraphId: string
  destinationId: string
  destinationType: string
  syncFrequency: Syncfrequency_String
  syncId: string
}

export interface AudienceSyncCreated {
  audienceId: string
  dataGraphId: string
  destinationId: string
  destinationType: string
  syncId: string
}

export interface AudienceSyncDeleted {
  audienceId: string
  syncId: string
}

export interface AudienceSyncDetailViewed {
  audienceId: string
  destinationId: string
  destinationType: string
  syncId: string
}

export interface AudienceSyncEdited {
  audienceId: string
  destinationId: string
  destinationType: string
  syncId: string
}

export interface AudienceSyncExecuted {
  audienceId: string
  dataGraphId: string
  destinationId: string
  destinationType: string
  organizationId: string
  sourceId: string
  sourceType: string
  workspaceId: string
}

export interface AudienceSyncToggled {
  audienceId: string
  syncId: string
  toggleValue: boolean
}

export interface BotBlockingConfigured {
  blockingMode: Blockingmode_String
  isEnabled: boolean
  scope: string
  sourceId?: string
}

export interface BotDetectionToggled {
  isEnabled: boolean
  scope: string
  sourceId?: string
}

export interface CatalogEventCreated {
  category?: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  eventName: string
  eventType: Eventtype_String
}

export interface CatalogEventDeleted {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  eventName: string
  eventType: Eventtype_String
}

export interface CatalogPropertyCreated {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  propertyName: string
  propertyType: Propertytype_String
}

export interface CatalogPropertyDeleted {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  propertyName: string
  propertyType: Propertytype_String
}

export interface CheckoutAbandoned {
  abandonmentReason?: Abandonmentreason_String
  lastStepReached: string
  selectedBillingCycle: CustomTypeDefs['Billing_cycle_type']
  selectedVolumeTier: CustomTypeDefs['Volume_tier_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeInCheckoutSeconds: number
}

export interface CheckoutCompleted {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  amount: number
  billingCycle: CustomTypeDefs['Billing_cycle_type']
  currency: Currency_String
  isFirstPaidPlan: boolean
  organizationId: string
  paymentMethodType: Paymentmethodtype_String
  planName: CustomTypeDefs['Plan_name_type']
  previousPlan: string
  referralSource: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceSignupSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceTrialStartSeconds?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialDaysUsed?: number
  volumeTier: CustomTypeDefs['Volume_tier_type']
}

export interface CheckoutError {
  errorCode?: string
  errorType: Errortype_String
  isRetry: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  retryCount: number
  stepWhereFailed: Stepwherefailed_String
}

export interface CheckoutStarted {
  referralSource: string
  selectedBillingCycle: CustomTypeDefs['Billing_cycle_type']
  selectedPlan: string
  selectedVolumeTier: CustomTypeDefs['Volume_tier_type']
}

export interface CheckoutStepCompleted {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepNumber: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeInStepSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
}

export interface Click {
  contextObjectId?: string
  contextObjectType?: string
  ctaName: string
  elementText?: string
  elementType?: string
  entryPoint?: string
  pageSection?: string
  targetUrl?: string
}

export interface ConfigReactivated {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  daysSinceDowngrade: number
  newPlan: string
  organizationId: string
  previousTrialFeaturesUsed?: any[]
  reactivatedResources: any[]
}

export interface ConnectionCreated {
  connectionMode?: Connectionmode_String
  creationMethod?: string
  destinationCategory?: Destinationcategory_String
  destinationId: string
  destinationType: string
  isFirstConnection?: boolean
  isFirstConnectionInOrg?: boolean
  sourceCategory?: Sourcecategory_String
  sourceId: string
  sourceType?: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalConnectionsCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalUniqueDestinationTypesCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalUniqueSourceTypesCount?: number
}

export interface ConnectionRemoved {
  destinationCategory: Destinationcategory_String
  destinationId: string
  destinationType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  remainingConnectionsCount: number
  sourceCategory: Sourcecategory_String
  sourceId: string
  sourceType: string
}

export interface DataGraphAudienceHydrated {
  audienceId: string
  dataGraphId: string
  organizationId: string
  workspaceId: string
}

export interface DataGraphColumnMetadataUpdated {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  aliasedCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  columnsChangedCount: number
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  describedCount?: number
  modelId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  piiMaskDisabledCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  piiMaskEnabledCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  suggestionsDisabledCount?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  suggestionsEnabledCount?: number
}

export interface DataGraphColumnSuggestionsSkipped {
  columnName: string
  dataGraphId: string
  skipReason: Skipreason_String
}

export interface DataGraphCreated {
  dataGraphId: string
  warehouseType: Warehousetype_String
}

export interface DataGraphDeleted {
  dataGraphId: string
}

export interface DataGraphModelCreated {
  dataGraphId: string
  modelId: string
  modelType: Modeltype_String
}

export interface DataGraphModelDeleted {
  dataGraphId: string
  modelId: string
  modelType: Modeltype_String
}

export interface DataGraphModelUpdated {
  dataGraphId: string
  modelId: string
  modelType: Modeltype_String
}

export interface DataGraphRelationshipCreated {
  dataGraphId: string
  relationshipId: string
  relationshipType: Relationshiptype_String
  sourceModelId: string
  targetModelId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalRelationshipsCount: number
}

export interface DataGraphRelationshipDeleted {
  dataGraphId: string
  relationshipId: string
}

export interface DataGraphViewed {
  dataGraphId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  modelsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  relationshipsCount: number
}

export interface DestinationCreated {
  connectionMode: Connectionmode_String
  destinationCategory: Destinationcategory_String
  destinationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  destinationName: string
  destinationType: string
  isFirstDestination: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalDestinationsCount: number
}

export interface DestinationDeleted {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  connectedSourcesCount: number
  destinationCategory: Destinationcategory_String
  destinationId: string
  destinationType: string
  hadActiveConnections: boolean
}

export interface DestinationDisabled {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  connectedSourcesCount: number
  destinationCategory: Destinationcategory_String
  destinationId: string
  destinationType: string
}

export interface DestinationEnabled {
  destinationCategory: Destinationcategory_String
  destinationId: string
  destinationType: string
}

export interface DestinationSetupStarted {
  destinationCategory: Destinationcategory_String
  destinationType: string
  entryPoint: string
}

export interface DestinationSetupStepCompleted {
  destinationCategory: Destinationcategory_String
  destinationType: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepNumber: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
}

export interface DirectorySearched {
  resultSelected: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  resultsCount: number
  searchQuery: string
  tab: string
}

export interface DirectoryViewed {
  subTab?: string
  tab: string
}

export interface EventBlockingRuleCreated {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  blockedEventName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  blockingLimit: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalBlockedEventsCount: number
}

export interface EventBlockingRuleRemoved {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  remainingBlockedEventsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  unblockedEventName: string
}

export interface EventBlockingToggled {
  isEnabled: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalBlockedEventsCount: number
}

export interface FeatureGateEncountered {
  currentPlan: string
  entryPoint: string
  featureName: Featurename_String
  requiredPlan: Requiredplan_String
}

export interface GettingStartedCompleted {
  activationSectionUnlocked: boolean
  sectionsCompleted: any[]
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepsSkippedCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceFirstLoginSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceSignupSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalConnectionsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalDestinationsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSourcesCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
}

export interface GettingStartedStepCompleted {
  isSectionComplete: boolean
  sectionName: Sectionname_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  sectionStepsCompleted: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  sectionTotalSteps: number
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepNumber: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepsRemaining: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceSignupSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
}

export interface HealthDashboardViewed {
  tab: string
  timeRange: Timerange_String
}

export interface HealthResourceInspected {
  destinationId?: string
  resourceCategory: Resourcecategory_String
  resourceStatus: Resourcestatus_String
  sourceId?: string
  trackingPlanId?: string
}

export interface IntegrationRequested {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  integrationName: string
  integrationType: Integrationtype_String
}

export interface LiveEventsViewed {
  resourceId: string
  resourceIntegrationType: string
  resourceType: string
}

export interface ModelCreated {
  isFirstModel: boolean
  modelId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  modelName: string
  warehouseType: Warehousetype_String
}

export interface ModelDeleted {
  hadActiveSyncs: boolean
  modelId: string
}

export interface OnboardingStepCompleted {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepNumber: number
  wasSkipped: boolean
}

export interface OverageInvoiceGenerated {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  actualEventVolume: number
  billingCycle: CustomTypeDefs['Billing_cycle_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  consecutiveOverageMonths: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  cpmRate: number
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  overageAmount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  overageEvents: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  tierEventLimit: number
  volumeTier: CustomTypeDefs['Volume_tier_type']
}

export interface PaymentFailed {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  amount: number
  email: string
  organizationId: string
}

export interface PaymentSucceeded {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  amount: number
  email: string
  organizationId: string
}

export interface PipelineFirstDeliveryCompleted {
  connectionMode: Connectionmode_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  deliveryLatencyMs: number
  destinationCategory: Destinationcategory_String
  destinationId: string
  destinationType: string
  isFirstDeliveryInWorkspace: boolean
  organizationId: string
  sourceId: string
  sourceType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceConnectionCreatedSeconds: number
  workspaceId: string
}

export interface PipelineFirstEventReceived {
  isFirstSourceEventInWorkspace: boolean
  organizationId: string
  sourceCategory: Sourcecategory_String
  sourceId: string
  sourceType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceSourceCreatedSeconds: number
  workspaceId: string
}

export interface PipelineValidationCompleted {
  destinationType?: string
  errorMessage?: string
  failedStep?: string
  resourceType: string
  sourceType?: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepsPassed?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps?: number
  validationStatus: Validationstatus_String
}

export interface PlanChanged {
  actorUserId?: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  annualContractValue?: number
  billingCycle?: CustomTypeDefs['Billing_cycle_type']
  changeType: Changetype_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  newEventAllocation?: number
  newPlan: string
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  previousEventAllocation?: number
  previousPlan: string
  volumeTier?: CustomTypeDefs['Volume_tier_type']
}

export interface PlanLimitApproached {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  currentUsage: number
  limitType: Limittype_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  planLimit: number
  threshold: Threshold_Integer
  /**
   * Advanced Validation Rules:
   *
   * - maximum: `100` → Highest allowed value (inclusive).
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  usagePercentage: number
}

export interface PlanLimitReached {
  blockedAction: string
  limitType: Limittype_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  planLimit: number
}

export interface PlanSelected {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  annualPrice?: number
  isTierChange: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  monthlyPrice: number
  previousBillingCycle?: string
  previousVolumeTier?: string
  selectedBillingCycle: CustomTypeDefs['Billing_cycle_type']
  selectedPlan: string
  selectedVolumeTier: CustomTypeDefs['Volume_tier_type']
}

export interface PricingPageViewed {
  currentPlan: string
  isTrial: boolean
  referralSource: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialDaysRemaining?: number
}

export interface ProfilesArtifactsViewed {
  projectId: string
  runId: string
  runStatus: string
}

export interface ProfilesProjectConverted {
  gitProvider: Gitprovider_String
  projectId: string
}

export interface ProfilesProjectCreated {
  creationFlow: Creationflow_String
  gitProvider?: Gitprovider_String
  projectId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  projectName: string
  scheduleType?: Scheduletype_String
  warehouseType: Warehousetype_String
}

export interface ProfilesProjectCreationStarted {
  creationFlow: Creationflow_String
}

export interface ProfilesRunCompleted {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  durationSeconds: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  entitiesProcessedCount?: number
  isFirstSuccessfulRun: boolean
  organizationId: string
  projectId: string
  runId: string
  runStatus: string
  workspaceId: string
}

export interface ProfilesRunStarted {
  projectId: string
  triggerType: Triggertype_String
}

export interface ResourceLimitReached {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  currentCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  planLimit: number
  resourceType: string
}

export interface RetlSourceCreated {
  audienceId?: string
  dataOrigin: Dataorigin_String
  modelId?: string
  sourceId: string
  sourceType: string
}

export interface RetlSyncCompleted {
  destinationId: string
  destinationType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  durationSeconds: number
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  recordsSyncedCount: number
  sourceId: string
  syncStatus: Syncstatus_String
  triggerType: Triggertype_String
  workspaceId: string
}

export interface RetlSyncTriggered {
  destinationId: string
  destinationType: string
  sourceId: string
}

export interface ServiceTokenCreated {
  tokenScope: Tokenscope_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalTokensCount: number
  workspaceId?: string
}

export interface SourceCreated {
  isFirstSource: boolean
  sourceCategory: Sourcecategory_String
  sourceId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  sourceName: string
  sourceType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSourcesCount: number
}

export interface SourceDeleted {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  connectedDestinationsCount: number
  hadActiveConnections: boolean
  sourceCategory: Sourcecategory_String
  sourceId: string
  sourceType: string
}

export interface SourceDisabled {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  connectedDestinationsCount: number
  sourceCategory: Sourcecategory_String
  sourceId: string
  sourceType: string
}

export interface SourceEnabled {
  sourceCategory: Sourcecategory_String
  sourceId: string
  sourceType: string
}

export interface SourceSetupStarted {
  entryPoint: string
  sourceCategory: Sourcecategory_String
  sourceType: string
}

export interface SourceSetupStepCompleted {
  sourceCategory: Sourcecategory_String
  sourceType: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepName: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepNumber: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
}

export interface SubscriptionCancelled {
  billingCycle?: CustomTypeDefs['Billing_cycle_type']
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  cancellationReason?: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  effectiveDate: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  monthsAsCustomer?: number
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  peakEventVolume?: number
  planName?: CustomTypeDefs['Plan_name_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalLifetimeRevenue?: number
  volumeTier?: CustomTypeDefs['Volume_tier_type']
}

export interface SubscriptionRenewed {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  amount: number
  billingCycle: CustomTypeDefs['Billing_cycle_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  monthsAsCustomer: number
  organizationId: string
  planName: CustomTypeDefs['Plan_name_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  renewalCount: number
  volumeTier: CustomTypeDefs['Volume_tier_type']
}

export interface SyncRetryTriggered {
  destinationId: string
  destinationType: string
  errorCategory?: string
  resourceType: string
  sourceId?: string
}

export interface TeamMemberInvited {
  invitedEmailDomain: string
  invitedRole: string
  invitedToWorkspaceId?: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  teamLimit: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalMembersCount: number
}

export interface TeamMemberRoleChanged {
  newRole: string
  previousRole: string
  scope: string
  targetUserId: string
}

export interface TrackingPlanConnected {
  dropEventsEnabled: boolean
  sourceId: string
  sourceType: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalConnectedSourcesCount: number
  trackingPlanId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trackingPlanName: string
}

export interface TrackingPlanCreated {
  creationMethod: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  initialEventsCount: number
  isFirstTrackingPlan: boolean
  trackingPlanId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trackingPlanName: string
}

export interface TrackingPlanDisconnected {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  remainingConnectedSourcesCount: number
  sourceId: string
  trackingPlanId: string
}

export interface TrackingPlanEdited {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalEventsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalPropertiesCount: number
  trackingPlanId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trackingPlanName: string
}

export interface TrackingPlanViolationDetected {
  actionTaken: string
  organizationId: string
  sourceId: string
  trackingPlanId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  violatingEventName: string
  violationType: Violationtype_String
  workspaceId: string
}

export interface TransformationConnected {
  destinationId: string
  destinationMode: Destinationmode_String
  destinationType: string
  language: Language_String
  transformationId: string
}

export interface TransformationCreated {
  isFirstTransformation: boolean
  language: Language_String
  templateType: Templatetype_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalTransformationsCount: number
  transformationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  transformationName: string
}

export interface TransformationDeleted {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  connectedDestinationsCount: number
  language: Language_String
  transformationId: string
  wasConnected: boolean
}

export interface TransformationDisconnected {
  destinationId: string
  destinationType: string
  transformationId: string
}

export interface TransformationLibraryCreated {
  libraryId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  libraryName: string
}

export interface TransformationPublished {
  hasDescription: boolean
  language: Language_String
  transformationId: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  versionNumber: number
}

export interface TransformationTested {
  language: Language_String
  testResult: Testresult_String
  transformationId: string
}

export interface TrialCompleted {
  email: string
  organizationId: string
  trialType: string
}

export interface TrialExpired {
  activationStatus: Activationstatus_String
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  configPreservedUntil?: string
  configsPreserved: boolean
  email: string
  featuresUsed: any[]
  organizationId: string
  outcome: Outcome_String
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  peakEventVolume?: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  teamSize: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialDurationDays: number
}

export interface TrialExtended {
  cumulativeEventCapReset: boolean
  email: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  extendDays: number
  extendedByUserId: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  newEndDate: string
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  previousEndDate: string
  reason: string
}

export interface TrialGracePeriodStarted {
  activationStatus?: Activationstatus_String
  email: string
  featuresUsed?: any[]
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  gracePeriodEndDate: string
  organizationId: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialEndDate: string
}

export interface TrialMigrationWizardCompleted {
  actionTaken: string
  resourcesFrozen: any[]
  resourcesKept: any[]
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  timeSinceTrialExpiredSeconds: number
}

export interface TrialStarted {
  email: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  eventCap: number
  organizationId: string
  previousPlan: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialEndDate: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialStartDate: string
  trialType: string
  trigger: Trigger_String
  workspaceId: string
}

export interface TrialWarningShown {
  ctaClicked: boolean
  ctaShown: string
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  daysRemaining: number
  warningPhase: Warningphase_String
  warningType: Warningtype_String
}

export interface UpgradeCtaClicked {
  ctaLocation: Ctalocation_String
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  ctaText: string
  destinationPage: Destinationpage_String
  triggerContext?: string
}

export interface UpgradeCtaViewed {
  ctaLocation: Ctalocation_String
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  ctaText: string
  triggerContext?: string
}

export interface UserCompletedOnboarding {
  completionStatus: Completionstatus_String
  questionHowDidYouHear?: string
  questionMigratingFrom?: string
  questionProductInterest?: any[]
  scheduledCall: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  stepsCompletedCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSteps: number
  userCompanyRole?: any[]
}

export interface UserLoggedIn {
  authMethod: Authmethod_String
  isMfa: boolean
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `1` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  loginCount: number
}

export interface UserSignedUp {
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  emailDomain: string
  invitedByUserId?: string
  isBusinessEmail: boolean
  isFirstUserInOrg: boolean
  organizationId: string
  signupMethod: Signupmethod_String
  userId: string
  workspaceId?: string
}

export interface WorkspaceCreated {
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalWorkspacesCount: number
  workspaceId: string
  /**
   * Advanced Validation Rules:
   *
   * - minLength: `1` → Minimum required characters.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  workspaceName: string
  workspacePurpose?: Workspacepurpose_String
}

export interface WorkspaceSettingsUpdated {
  newValue?: string
  settingChanged: string
}

export interface WorkspaceSwitched {
  fromWorkspaceId: string
  toWorkspaceId: string
}

export interface Page {
  pageCategory: Pagecategory_String
  pageName: string
}

export interface Group {
  billingCycle?: CustomTypeDefs['Billing_cycle_type']
  environment: CustomTypeDefs['Environment_type']
  isTrial: boolean
  orgConnectionCreated: boolean
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  orgCreatedAt: string
  orgName: string
  planName: CustomTypeDefs['Plan_name_type']
  region: CustomTypeDefs['Region_type']
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalConnectionsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalDestinationsCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalMembersCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalSourcesCount: number
  /**
   * Advanced Validation Rules:
   *
   * - minimum: `0` → Lowest allowed value (inclusive).
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  totalWorkspacesCount: number
}

export interface Identify {
  billingCycle?: CustomTypeDefs['Billing_cycle_type']
  company?: string
  email: string
  environment: CustomTypeDefs['Environment_type']
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  gracePeriodEndDate?: string
  isGracePeriod?: boolean
  isInternal?: boolean
  isTrial: boolean
  onboardingQuestionsStatus?: Onboardingquestionsstatus_String
  organizationId: string
  planName: CustomTypeDefs['Plan_name_type']
  questionHowDidYouHear?: string
  questionMigratingFrom?: string
  questionProductInterest?: any[]
  region: CustomTypeDefs['Region_type']
  role: CustomTypeDefs['Role_type']
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialEndDate?: string
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  trialStartDate?: string
  userCompanyRole?: any[]
  /**
   * Advanced Validation Rules:
   *
   * - format: `date-time` → Expected format.
   *
   * These advanced rules ensure proper data validation and type safety.
   */
  userCreatedAt: string
  userName: string
  workspaceId: string
}

export type ViolationHandler = (
  message: Record<string, any>,
  violations: any[]
) => void

let analytics: () => any | undefined = () => {
  return window.rudderanalytics
}

/** Options to customize the runtime behavior of a RudderTyper client. */
export interface RudderTyperOptions {
  /**
   * Underlying analytics instance where analytics calls are forwarded on to.
   * Defaults to window.rudderanalytics.
   */
  analytics?: any
  /**
   * Handler fired when if an event does not match its spec. This handler
   * does not fire in production mode, because it requires inlining the full
   * JSON Schema spec for each event in your Tracking Plan.
   *
   * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
   * if a message does not match the spec. Otherwise, errors will be logged to stderr.
   */
  onViolation?: ViolationHandler
}

/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setRudderTyperOptions(options: RudderTyperOptions) {
  analytics = options.analytics
    ? () => options.analytics || window.rudderanalytics
    : analytics
}

/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext(message: ApiOptions = {}): ApiOptions {
  return {
    ...message,
    context: {
      ...((message.context as ApiObject) || {}),
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'typescript',
        rudderTyperVersion: '1.7.5',
        trackingPlanId: 'tp_3EfbYLRNvihOh0etbLRWFPjTPSd',
        trackingPlanVersion: 6,
      },
    },
  }
}

export type PlanNameType_String =
  | 'Free Tier'
  | 'Starter'
  | 'Pro'
  | 'Growth'
  | 'Enterprise'
  | 'Open source plan'

export type RegionType_String = 'US' | 'EU' | 'IN'

export type BillingCycleType_String = 'month' | 'year'

export type VolumeTierType_String =
  | '1m'
  | '3m'
  | '5m'
  | '7m'
  | '10m'
  | '25m'
  | '50m'
  | '100m'

export type EnvironmentType_String = 'PRODUCTION' | 'DEVELOPMENT'

export type RoleType_String = 'admin' | 'member'

export interface CustomTypeDefs {
  Plan_name_type?: PlanNameType_String
  Region_type?: RegionType_String
  Billing_cycle_type?: BillingCycleType_String
  Volume_tier_type?: VolumeTierType_String
  Environment_type?: EnvironmentType_String
  Role_type?: RoleType_String
}

/**
 * @typedef AccountCreated
 * @property {boolean} isTrial -
 * @property {string} organizationId -
 * @property {CustomTypeDefs['Plan_name_type']} planName -
 * @property {CustomTypeDefs['Region_type']} region -
 * @property {Signupsource_String} signupSource -
 */
/**
 * @typedef AlertConfigured
 * @property {Action_String} action -
 * @property {string} alertName -
 * @property {Resourcecategory_String} resourceCategory -
 * @property {string} resourceId -
 * @property {string} resourceType -
 */
/**
 * @typedef AlertToggled
 * @property {string} alertName -
 * @property {Channeltype_String} channelType -
 * @property {boolean} isEnabled -
 * @property {string} resourceId -
 */
/**
 * @typedef AudienceCreated
 * @property {string} audienceId -
 * @property {string} audienceName -
 * @property {Audiencetype_String} audienceType -
 * @property {string} dataGraphId -
 * @property {number} [expressionComplexity] -
 * @property {string} [profilesProjectId] -
 * @property {string} [rootModel] -
 */
/**
 * @typedef AudienceDeleted
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 */
/**
 * @typedef AudienceDetailViewed
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 * @property {number} syncCount -
 */
/**
 * @typedef AudienceExpressionEdited
 * @property {string} audienceId -
 * @property {Audiencetype_String} audienceType -
 * @property {number} conditionCount -
 * @property {string} dataGraphId -
 * @property {boolean} usesAggregates -
 * @property {boolean} usesRelationships -
 * @property {boolean} usesTimeWindows -
 */
/**
 * @typedef AudienceListViewed
 * @property {string} dataGraphId -
 * @property {number} totalAudiencesCount -
 */
/**
 * @typedef AudiencePreviewSubmitted
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 */
/**
 * @typedef AudienceRenamed
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 */
/**
 * @typedef AudienceSuggestionUsed
 * @property {string} [audienceId] -
 * @property {string} columnName -
 * @property {Conditionoperator_String} conditionOperator -
 * @property {string} dataGraphId -
 * @property {number} [suggestionsCount] -
 * @property {boolean} valueFromSuggestion -
 */
/**
 * @typedef AudienceSyncCompleted
 * @property {string} audienceId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {number} durationSeconds -
 * @property {string} organizationId -
 * @property {number} recordsSyncedCount -
 * @property {Syncstatus_String} syncStatus -
 * @property {string} workspaceId -
 */
/**
 * @typedef AudienceSyncConfigured
 * @property {string} audienceId -
 * @property {Audiencetype_String} audienceType -
 * @property {string} dataGraphId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {Syncfrequency_String} syncFrequency -
 * @property {string} syncId -
 */
/**
 * @typedef AudienceSyncCreated
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} syncId -
 */
/**
 * @typedef AudienceSyncDeleted
 * @property {string} audienceId -
 * @property {string} syncId -
 */
/**
 * @typedef AudienceSyncDetailViewed
 * @property {string} audienceId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} syncId -
 */
/**
 * @typedef AudienceSyncEdited
 * @property {string} audienceId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} syncId -
 */
/**
 * @typedef AudienceSyncExecuted
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} organizationId -
 * @property {string} sourceId -
 * @property {string} sourceType -
 * @property {string} workspaceId -
 */
/**
 * @typedef AudienceSyncToggled
 * @property {string} audienceId -
 * @property {string} syncId -
 * @property {boolean} toggleValue -
 */
/**
 * @typedef BotBlockingConfigured
 * @property {Blockingmode_String} blockingMode -
 * @property {boolean} isEnabled -
 * @property {string} scope -
 * @property {string} [sourceId] -
 */
/**
 * @typedef BotDetectionToggled
 * @property {boolean} isEnabled -
 * @property {string} scope -
 * @property {string} [sourceId] -
 */
/**
 * @typedef CatalogEventCreated
 * @property {string} [category] -
 * @property {string} eventName -
 * @property {Eventtype_String} eventType -
 */
/**
 * @typedef CatalogEventDeleted
 * @property {string} eventName -
 * @property {Eventtype_String} eventType -
 */
/**
 * @typedef CatalogPropertyCreated
 * @property {string} propertyName -
 * @property {Propertytype_String} propertyType -
 */
/**
 * @typedef CatalogPropertyDeleted
 * @property {string} propertyName -
 * @property {Propertytype_String} propertyType -
 */
/**
 * @typedef CheckoutAbandoned
 * @property {Abandonmentreason_String} [abandonmentReason] -
 * @property {string} lastStepReached -
 * @property {CustomTypeDefs['Billing_cycle_type']} selectedBillingCycle -
 * @property {CustomTypeDefs['Volume_tier_type']} selectedVolumeTier -
 * @property {number} timeInCheckoutSeconds -
 */
/**
 * @typedef CheckoutCompleted
 * @property {number} amount -
 * @property {CustomTypeDefs['Billing_cycle_type']} billingCycle -
 * @property {Currency_String} currency -
 * @property {boolean} isFirstPaidPlan -
 * @property {string} organizationId -
 * @property {Paymentmethodtype_String} paymentMethodType -
 * @property {CustomTypeDefs['Plan_name_type']} planName -
 * @property {string} previousPlan -
 * @property {string} referralSource -
 * @property {number} timeSinceSignupSeconds -
 * @property {number} [timeSinceTrialStartSeconds] -
 * @property {number} [trialDaysUsed] -
 * @property {CustomTypeDefs['Volume_tier_type']} volumeTier -
 */
/**
 * @typedef CheckoutError
 * @property {string} [errorCode] -
 * @property {Errortype_String} errorType -
 * @property {boolean} isRetry -
 * @property {number} retryCount -
 * @property {Stepwherefailed_String} stepWhereFailed -
 */
/**
 * @typedef CheckoutStarted
 * @property {string} referralSource -
 * @property {CustomTypeDefs['Billing_cycle_type']} selectedBillingCycle -
 * @property {string} selectedPlan -
 * @property {CustomTypeDefs['Volume_tier_type']} selectedVolumeTier -
 */
/**
 * @typedef CheckoutStepCompleted
 * @property {string} stepName -
 * @property {number} stepNumber -
 * @property {number} timeInStepSeconds -
 * @property {number} totalSteps -
 */
/**
 * @typedef Click
 * @property {string} [contextObjectId] -
 * @property {string} [contextObjectType] -
 * @property {string} ctaName -
 * @property {string} [elementText] -
 * @property {string} [elementType] -
 * @property {string} [entryPoint] -
 * @property {string} [pageSection] -
 * @property {string} [targetUrl] -
 */
/**
 * @typedef ConfigReactivated
 * @property {number} daysSinceDowngrade -
 * @property {string} newPlan -
 * @property {string} organizationId -
 * @property {any[]} [previousTrialFeaturesUsed] -
 * @property {any[]} reactivatedResources -
 */
/**
 * @typedef ConnectionCreated
 * @property {Connectionmode_String} [connectionMode] -
 * @property {string} [creationMethod] -
 * @property {Destinationcategory_String} [destinationCategory] -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {boolean} [isFirstConnection] -
 * @property {boolean} [isFirstConnectionInOrg] -
 * @property {Sourcecategory_String} [sourceCategory] -
 * @property {string} sourceId -
 * @property {string} [sourceType] -
 * @property {number} [totalConnectionsCount] -
 * @property {number} [totalUniqueDestinationTypesCount] -
 * @property {number} [totalUniqueSourceTypesCount] -
 */
/**
 * @typedef ConnectionRemoved
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {number} remainingConnectionsCount -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceType -
 */
/**
 * @typedef DataGraphAudienceHydrated
 * @property {string} audienceId -
 * @property {string} dataGraphId -
 * @property {string} organizationId -
 * @property {string} workspaceId -
 */
/**
 * @typedef DataGraphColumnMetadataUpdated
 * @property {number} [aliasedCount] -
 * @property {number} columnsChangedCount -
 * @property {string} dataGraphId -
 * @property {number} [describedCount] -
 * @property {string} modelId -
 * @property {number} [piiMaskDisabledCount] -
 * @property {number} [piiMaskEnabledCount] -
 * @property {number} [suggestionsDisabledCount] -
 * @property {number} [suggestionsEnabledCount] -
 */
/**
 * @typedef DataGraphColumnSuggestionsSkipped
 * @property {string} columnName -
 * @property {string} dataGraphId -
 * @property {Skipreason_String} skipReason -
 */
/**
 * @typedef DataGraphCreated
 * @property {string} dataGraphId -
 * @property {Warehousetype_String} warehouseType -
 */
/**
 * @typedef DataGraphDeleted
 * @property {string} dataGraphId -
 */
/**
 * @typedef DataGraphModelCreated
 * @property {string} dataGraphId -
 * @property {string} modelId -
 * @property {Modeltype_String} modelType -
 */
/**
 * @typedef DataGraphModelDeleted
 * @property {string} dataGraphId -
 * @property {string} modelId -
 * @property {Modeltype_String} modelType -
 */
/**
 * @typedef DataGraphModelUpdated
 * @property {string} dataGraphId -
 * @property {string} modelId -
 * @property {Modeltype_String} modelType -
 */
/**
 * @typedef DataGraphRelationshipCreated
 * @property {string} dataGraphId -
 * @property {string} relationshipId -
 * @property {Relationshiptype_String} relationshipType -
 * @property {string} sourceModelId -
 * @property {string} targetModelId -
 * @property {number} totalRelationshipsCount -
 */
/**
 * @typedef DataGraphRelationshipDeleted
 * @property {string} dataGraphId -
 * @property {string} relationshipId -
 */
/**
 * @typedef DataGraphViewed
 * @property {string} dataGraphId -
 * @property {number} modelsCount -
 * @property {number} relationshipsCount -
 */
/**
 * @typedef DestinationCreated
 * @property {Connectionmode_String} connectionMode -
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationName -
 * @property {string} destinationType -
 * @property {boolean} isFirstDestination -
 * @property {number} totalDestinationsCount -
 */
/**
 * @typedef DestinationDeleted
 * @property {number} connectedSourcesCount -
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {boolean} hadActiveConnections -
 */
/**
 * @typedef DestinationDisabled
 * @property {number} connectedSourcesCount -
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationType -
 */
/**
 * @typedef DestinationEnabled
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationType -
 */
/**
 * @typedef DestinationSetupStarted
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationType -
 * @property {string} entryPoint -
 */
/**
 * @typedef DestinationSetupStepCompleted
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationType -
 * @property {string} stepName -
 * @property {number} stepNumber -
 * @property {number} totalSteps -
 */
/**
 * @typedef DirectorySearched
 * @property {boolean} resultSelected -
 * @property {number} resultsCount -
 * @property {string} searchQuery -
 * @property {string} tab -
 */
/**
 * @typedef DirectoryViewed
 * @property {string} [subTab] -
 * @property {string} tab -
 */
/**
 * @typedef EventBlockingRuleCreated
 * @property {string} blockedEventName -
 * @property {number} blockingLimit -
 * @property {number} totalBlockedEventsCount -
 */
/**
 * @typedef EventBlockingRuleRemoved
 * @property {number} remainingBlockedEventsCount -
 * @property {string} unblockedEventName -
 */
/**
 * @typedef EventBlockingToggled
 * @property {boolean} isEnabled -
 * @property {number} totalBlockedEventsCount -
 */
/**
 * @typedef FeatureGateEncountered
 * @property {string} currentPlan -
 * @property {string} entryPoint -
 * @property {Featurename_String} featureName -
 * @property {Requiredplan_String} requiredPlan -
 */
/**
 * @typedef GettingStartedCompleted
 * @property {boolean} activationSectionUnlocked -
 * @property {any[]} sectionsCompleted -
 * @property {number} stepsSkippedCount -
 * @property {number} timeSinceFirstLoginSeconds -
 * @property {number} timeSinceSignupSeconds -
 * @property {number} totalConnectionsCount -
 * @property {number} totalDestinationsCount -
 * @property {number} totalSourcesCount -
 * @property {number} totalSteps -
 */
/**
 * @typedef GettingStartedStepCompleted
 * @property {boolean} isSectionComplete -
 * @property {Sectionname_String} sectionName -
 * @property {number} sectionStepsCompleted -
 * @property {number} sectionTotalSteps -
 * @property {string} stepName -
 * @property {number} stepNumber -
 * @property {number} stepsRemaining -
 * @property {number} timeSinceSignupSeconds -
 * @property {number} totalSteps -
 */
/**
 * @typedef HealthDashboardViewed
 * @property {string} tab -
 * @property {Timerange_String} timeRange -
 */
/**
 * @typedef HealthResourceInspected
 * @property {string} [destinationId] -
 * @property {Resourcecategory_String} resourceCategory -
 * @property {Resourcestatus_String} resourceStatus -
 * @property {string} [sourceId] -
 * @property {string} [trackingPlanId] -
 */
/**
 * @typedef IntegrationRequested
 * @property {string} integrationName -
 * @property {Integrationtype_String} integrationType -
 */
/**
 * @typedef LiveEventsViewed
 * @property {string} resourceId -
 * @property {string} resourceIntegrationType -
 * @property {string} resourceType -
 */
/**
 * @typedef ModelCreated
 * @property {boolean} isFirstModel -
 * @property {string} modelId -
 * @property {string} modelName -
 * @property {Warehousetype_String} warehouseType -
 */
/**
 * @typedef ModelDeleted
 * @property {boolean} hadActiveSyncs -
 * @property {string} modelId -
 */
/**
 * @typedef OnboardingStepCompleted
 * @property {string} stepName -
 * @property {number} stepNumber -
 * @property {boolean} wasSkipped -
 */
/**
 * @typedef OverageInvoiceGenerated
 * @property {number} actualEventVolume -
 * @property {CustomTypeDefs['Billing_cycle_type']} billingCycle -
 * @property {number} consecutiveOverageMonths -
 * @property {number} cpmRate -
 * @property {string} organizationId -
 * @property {number} overageAmount -
 * @property {number} overageEvents -
 * @property {number} tierEventLimit -
 * @property {CustomTypeDefs['Volume_tier_type']} volumeTier -
 */
/**
 * @typedef PaymentFailed
 * @property {number} amount -
 * @property {string} email -
 * @property {string} organizationId -
 */
/**
 * @typedef PaymentSucceeded
 * @property {number} amount -
 * @property {string} email -
 * @property {string} organizationId -
 */
/**
 * @typedef PipelineFirstDeliveryCompleted
 * @property {Connectionmode_String} connectionMode -
 * @property {number} deliveryLatencyMs -
 * @property {Destinationcategory_String} destinationCategory -
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {boolean} isFirstDeliveryInWorkspace -
 * @property {string} organizationId -
 * @property {string} sourceId -
 * @property {string} sourceType -
 * @property {number} timeSinceConnectionCreatedSeconds -
 * @property {string} workspaceId -
 */
/**
 * @typedef PipelineFirstEventReceived
 * @property {boolean} isFirstSourceEventInWorkspace -
 * @property {string} organizationId -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceType -
 * @property {number} timeSinceSourceCreatedSeconds -
 * @property {string} workspaceId -
 */
/**
 * @typedef PipelineValidationCompleted
 * @property {string} [destinationType] -
 * @property {string} [errorMessage] -
 * @property {string} [failedStep] -
 * @property {string} resourceType -
 * @property {string} [sourceType] -
 * @property {number} [stepsPassed] -
 * @property {number} [totalSteps] -
 * @property {Validationstatus_String} validationStatus -
 */
/**
 * @typedef PlanChanged
 * @property {string} [actorUserId] -
 * @property {number} [annualContractValue] -
 * @property {CustomTypeDefs['Billing_cycle_type']} [billingCycle] -
 * @property {Changetype_String} changeType -
 * @property {number} [newEventAllocation] -
 * @property {string} newPlan -
 * @property {string} organizationId -
 * @property {number} [previousEventAllocation] -
 * @property {string} previousPlan -
 * @property {CustomTypeDefs['Volume_tier_type']} [volumeTier] -
 */
/**
 * @typedef PlanLimitApproached
 * @property {number} currentUsage -
 * @property {Limittype_String} limitType -
 * @property {number} planLimit -
 * @property {Threshold_Integer} threshold -
 * @property {number} usagePercentage -
 */
/**
 * @typedef PlanLimitReached
 * @property {string} blockedAction -
 * @property {Limittype_String} limitType -
 * @property {number} planLimit -
 */
/**
 * @typedef PlanSelected
 * @property {number} [annualPrice] -
 * @property {boolean} isTierChange -
 * @property {number} monthlyPrice -
 * @property {string} [previousBillingCycle] -
 * @property {string} [previousVolumeTier] -
 * @property {CustomTypeDefs['Billing_cycle_type']} selectedBillingCycle -
 * @property {string} selectedPlan -
 * @property {CustomTypeDefs['Volume_tier_type']} selectedVolumeTier -
 */
/**
 * @typedef PricingPageViewed
 * @property {string} currentPlan -
 * @property {boolean} isTrial -
 * @property {string} referralSource -
 * @property {number} [trialDaysRemaining] -
 */
/**
 * @typedef ProfilesArtifactsViewed
 * @property {string} projectId -
 * @property {string} runId -
 * @property {string} runStatus -
 */
/**
 * @typedef ProfilesProjectConverted
 * @property {Gitprovider_String} gitProvider -
 * @property {string} projectId -
 */
/**
 * @typedef ProfilesProjectCreated
 * @property {Creationflow_String} creationFlow -
 * @property {Gitprovider_String} [gitProvider] -
 * @property {string} projectId -
 * @property {string} projectName -
 * @property {Scheduletype_String} [scheduleType] -
 * @property {Warehousetype_String} warehouseType -
 */
/**
 * @typedef ProfilesProjectCreationStarted
 * @property {Creationflow_String} creationFlow -
 */
/**
 * @typedef ProfilesRunCompleted
 * @property {number} durationSeconds -
 * @property {number} [entitiesProcessedCount] -
 * @property {boolean} isFirstSuccessfulRun -
 * @property {string} organizationId -
 * @property {string} projectId -
 * @property {string} runId -
 * @property {string} runStatus -
 * @property {string} workspaceId -
 */
/**
 * @typedef ProfilesRunStarted
 * @property {string} projectId -
 * @property {Triggertype_String} triggerType -
 */
/**
 * @typedef ResourceLimitReached
 * @property {number} currentCount -
 * @property {number} planLimit -
 * @property {string} resourceType -
 */
/**
 * @typedef RetlSourceCreated
 * @property {string} [audienceId] -
 * @property {Dataorigin_String} dataOrigin -
 * @property {string} [modelId] -
 * @property {string} sourceId -
 * @property {string} sourceType -
 */
/**
 * @typedef RetlSyncCompleted
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {number} durationSeconds -
 * @property {string} organizationId -
 * @property {number} recordsSyncedCount -
 * @property {string} sourceId -
 * @property {Syncstatus_String} syncStatus -
 * @property {Triggertype_String} triggerType -
 * @property {string} workspaceId -
 */
/**
 * @typedef RetlSyncTriggered
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} sourceId -
 */
/**
 * @typedef ServiceTokenCreated
 * @property {Tokenscope_String} tokenScope -
 * @property {number} totalTokensCount -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef SourceCreated
 * @property {boolean} isFirstSource -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceName -
 * @property {string} sourceType -
 * @property {number} totalSourcesCount -
 */
/**
 * @typedef SourceDeleted
 * @property {number} connectedDestinationsCount -
 * @property {boolean} hadActiveConnections -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceType -
 */
/**
 * @typedef SourceDisabled
 * @property {number} connectedDestinationsCount -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceType -
 */
/**
 * @typedef SourceEnabled
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceId -
 * @property {string} sourceType -
 */
/**
 * @typedef SourceSetupStarted
 * @property {string} entryPoint -
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceType -
 */
/**
 * @typedef SourceSetupStepCompleted
 * @property {Sourcecategory_String} sourceCategory -
 * @property {string} sourceType -
 * @property {string} stepName -
 * @property {number} stepNumber -
 * @property {number} totalSteps -
 */
/**
 * @typedef SubscriptionCancelled
 * @property {CustomTypeDefs['Billing_cycle_type']} [billingCycle] -
 * @property {string} [cancellationReason] -
 * @property {string} effectiveDate -
 * @property {number} [monthsAsCustomer] -
 * @property {string} organizationId -
 * @property {number} [peakEventVolume] -
 * @property {CustomTypeDefs['Plan_name_type']} [planName] -
 * @property {number} [totalLifetimeRevenue] -
 * @property {CustomTypeDefs['Volume_tier_type']} [volumeTier] -
 */
/**
 * @typedef SubscriptionRenewed
 * @property {number} amount -
 * @property {CustomTypeDefs['Billing_cycle_type']} billingCycle -
 * @property {number} monthsAsCustomer -
 * @property {string} organizationId -
 * @property {CustomTypeDefs['Plan_name_type']} planName -
 * @property {number} renewalCount -
 * @property {CustomTypeDefs['Volume_tier_type']} volumeTier -
 */
/**
 * @typedef SyncRetryTriggered
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} [errorCategory] -
 * @property {string} resourceType -
 * @property {string} [sourceId] -
 */
/**
 * @typedef TeamMemberInvited
 * @property {string} invitedEmailDomain -
 * @property {string} invitedRole -
 * @property {string} [invitedToWorkspaceId] -
 * @property {number} teamLimit -
 * @property {number} totalMembersCount -
 */
/**
 * @typedef TeamMemberRoleChanged
 * @property {string} newRole -
 * @property {string} previousRole -
 * @property {string} scope -
 * @property {string} targetUserId -
 */
/**
 * @typedef TrackingPlanConnected
 * @property {boolean} dropEventsEnabled -
 * @property {string} sourceId -
 * @property {string} sourceType -
 * @property {number} totalConnectedSourcesCount -
 * @property {string} trackingPlanId -
 * @property {string} trackingPlanName -
 */
/**
 * @typedef TrackingPlanCreated
 * @property {string} creationMethod -
 * @property {number} initialEventsCount -
 * @property {boolean} isFirstTrackingPlan -
 * @property {string} trackingPlanId -
 * @property {string} trackingPlanName -
 */
/**
 * @typedef TrackingPlanDisconnected
 * @property {number} remainingConnectedSourcesCount -
 * @property {string} sourceId -
 * @property {string} trackingPlanId -
 */
/**
 * @typedef TrackingPlanEdited
 * @property {number} totalEventsCount -
 * @property {number} totalPropertiesCount -
 * @property {string} trackingPlanId -
 * @property {string} trackingPlanName -
 */
/**
 * @typedef TrackingPlanViolationDetected
 * @property {string} actionTaken -
 * @property {string} organizationId -
 * @property {string} sourceId -
 * @property {string} trackingPlanId -
 * @property {string} violatingEventName -
 * @property {Violationtype_String} violationType -
 * @property {string} workspaceId -
 */
/**
 * @typedef TransformationConnected
 * @property {string} destinationId -
 * @property {Destinationmode_String} destinationMode -
 * @property {string} destinationType -
 * @property {Language_String} language -
 * @property {string} transformationId -
 */
/**
 * @typedef TransformationCreated
 * @property {boolean} isFirstTransformation -
 * @property {Language_String} language -
 * @property {Templatetype_String} templateType -
 * @property {number} totalTransformationsCount -
 * @property {string} transformationId -
 * @property {string} transformationName -
 */
/**
 * @typedef TransformationDeleted
 * @property {number} connectedDestinationsCount -
 * @property {Language_String} language -
 * @property {string} transformationId -
 * @property {boolean} wasConnected -
 */
/**
 * @typedef TransformationDisconnected
 * @property {string} destinationId -
 * @property {string} destinationType -
 * @property {string} transformationId -
 */
/**
 * @typedef TransformationLibraryCreated
 * @property {string} libraryId -
 * @property {string} libraryName -
 */
/**
 * @typedef TransformationPublished
 * @property {boolean} hasDescription -
 * @property {Language_String} language -
 * @property {string} transformationId -
 * @property {number} versionNumber -
 */
/**
 * @typedef TransformationTested
 * @property {Language_String} language -
 * @property {Testresult_String} testResult -
 * @property {string} transformationId -
 */
/**
 * @typedef TrialCompleted
 * @property {string} email -
 * @property {string} organizationId -
 * @property {string} trialType -
 */
/**
 * @typedef TrialExpired
 * @property {Activationstatus_String} activationStatus -
 * @property {string} [configPreservedUntil] -
 * @property {boolean} configsPreserved -
 * @property {string} email -
 * @property {any[]} featuresUsed -
 * @property {string} organizationId -
 * @property {Outcome_String} outcome -
 * @property {number} [peakEventVolume] -
 * @property {number} teamSize -
 * @property {number} trialDurationDays -
 */
/**
 * @typedef TrialExtended
 * @property {boolean} cumulativeEventCapReset -
 * @property {string} email -
 * @property {number} extendDays -
 * @property {string} extendedByUserId -
 * @property {string} newEndDate -
 * @property {string} organizationId -
 * @property {string} previousEndDate -
 * @property {string} reason -
 */
/**
 * @typedef TrialGracePeriodStarted
 * @property {Activationstatus_String} [activationStatus] -
 * @property {string} email -
 * @property {any[]} [featuresUsed] -
 * @property {string} gracePeriodEndDate -
 * @property {string} organizationId -
 * @property {string} trialEndDate -
 */
/**
 * @typedef TrialMigrationWizardCompleted
 * @property {string} actionTaken -
 * @property {any[]} resourcesFrozen -
 * @property {any[]} resourcesKept -
 * @property {number} timeSinceTrialExpiredSeconds -
 */
/**
 * @typedef TrialStarted
 * @property {string} email -
 * @property {number} eventCap -
 * @property {string} organizationId -
 * @property {string} previousPlan -
 * @property {string} trialEndDate -
 * @property {string} trialStartDate -
 * @property {string} trialType -
 * @property {Trigger_String} trigger -
 * @property {string} workspaceId -
 */
/**
 * @typedef TrialWarningShown
 * @property {boolean} ctaClicked -
 * @property {string} ctaShown -
 * @property {number} daysRemaining -
 * @property {Warningphase_String} warningPhase -
 * @property {Warningtype_String} warningType -
 */
/**
 * @typedef UpgradeCtaClicked
 * @property {Ctalocation_String} ctaLocation -
 * @property {string} ctaText -
 * @property {Destinationpage_String} destinationPage -
 * @property {string} [triggerContext] -
 */
/**
 * @typedef UpgradeCtaViewed
 * @property {Ctalocation_String} ctaLocation -
 * @property {string} ctaText -
 * @property {string} [triggerContext] -
 */
/**
 * @typedef UserCompletedOnboarding
 * @property {Completionstatus_String} completionStatus -
 * @property {string} [questionHowDidYouHear] -
 * @property {string} [questionMigratingFrom] -
 * @property {any[]} [questionProductInterest] -
 * @property {boolean} scheduledCall -
 * @property {number} stepsCompletedCount -
 * @property {number} totalSteps -
 * @property {any[]} [userCompanyRole] -
 */
/**
 * @typedef UserLoggedIn
 * @property {Authmethod_String} authMethod -
 * @property {boolean} isMfa -
 * @property {number} loginCount -
 */
/**
 * @typedef UserSignedUp
 * @property {string} emailDomain -
 * @property {string} [invitedByUserId] -
 * @property {boolean} isBusinessEmail -
 * @property {boolean} isFirstUserInOrg -
 * @property {string} organizationId -
 * @property {Signupmethod_String} signupMethod -
 * @property {string} userId -
 * @property {string} [workspaceId] -
 */
/**
 * @typedef WorkspaceCreated
 * @property {number} totalWorkspacesCount -
 * @property {string} workspaceId -
 * @property {string} workspaceName -
 * @property {Workspacepurpose_String} [workspacePurpose] -
 */
/**
 * @typedef WorkspaceSettingsUpdated
 * @property {string} [newValue] -
 * @property {string} settingChanged -
 */
/**
 * @typedef WorkspaceSwitched
 * @property {string} fromWorkspaceId -
 * @property {string} toWorkspaceId -
 */
/**
 * @typedef Page
 * @property {Pagecategory_String} pageCategory -
 * @property {string} pageName -
 */
/**
 * @typedef Group
 * @property {CustomTypeDefs['Billing_cycle_type']} [billingCycle] -
 * @property {CustomTypeDefs['Environment_type']} environment -
 * @property {boolean} isTrial -
 * @property {boolean} orgConnectionCreated -
 * @property {string} orgCreatedAt -
 * @property {string} orgName -
 * @property {CustomTypeDefs['Plan_name_type']} planName -
 * @property {CustomTypeDefs['Region_type']} region -
 * @property {number} totalConnectionsCount -
 * @property {number} totalDestinationsCount -
 * @property {number} totalMembersCount -
 * @property {number} totalSourcesCount -
 * @property {number} totalWorkspacesCount -
 */
/**
 * @typedef Identify
 * @property {CustomTypeDefs['Billing_cycle_type']} [billingCycle] -
 * @property {string} [company] -
 * @property {string} email -
 * @property {CustomTypeDefs['Environment_type']} environment -
 * @property {string} [gracePeriodEndDate] -
 * @property {boolean} [isGracePeriod] -
 * @property {boolean} [isInternal] -
 * @property {boolean} isTrial -
 * @property {Onboardingquestionsstatus_String} [onboardingQuestionsStatus] -
 * @property {string} organizationId -
 * @property {CustomTypeDefs['Plan_name_type']} planName -
 * @property {string} [questionHowDidYouHear] -
 * @property {string} [questionMigratingFrom] -
 * @property {any[]} [questionProductInterest] -
 * @property {CustomTypeDefs['Region_type']} region -
 * @property {CustomTypeDefs['Role_type']} role -
 * @property {string} [trialEndDate] -
 * @property {string} [trialStartDate] -
 * @property {any[]} [userCompanyRole] -
 * @property {string} userCreatedAt -
 * @property {string} userName -
 * @property {string} workspaceId -
 */

/**
 * New organization record provisioned in the system (server-side)
 *
 * @param {AccountCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function accountCreated(
  props: AccountCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'accountCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates or modifies an alert rule
 *
 * @param {AlertConfigured} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function alertConfigured(
  props: AlertConfigured,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'alertConfigured',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User enables or disables a specific alert
 *
 * @param {AlertToggled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function alertToggled(
  props: AlertToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'alertToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New audience saved (Data Graph Audiences or Cohort Audiences)
 *
 * @param {AudienceCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceCreated(
  props: AudienceCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User deletes an audience
 *
 * @param {AudienceDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceDeleted(
  props: AudienceDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User opens an audience detail page
 *
 * @param {AudienceDetailViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceDetailViewed(
  props: AudienceDetailViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceDetailViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User modifies an audience expression in the builder
 *
 * @param {AudienceExpressionEdited} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceExpressionEdited(
  props: AudienceExpressionEdited,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceExpressionEdited',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User opens the audience list page for a Data Graph
 *
 * @param {AudienceListViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceListViewed(
  props: AudienceListViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceListViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User triggers an audience preview
 *
 * @param {AudiencePreviewSubmitted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audiencePreviewSubmitted(
  props: AudiencePreviewSubmitted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audiencePreviewSubmitted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User renames an audience
 *
 * @param {AudienceRenamed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceRenamed(
  props: AudienceRenamed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceRenamed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User committed an audience condition value on a value-suggestion-bearing string column; captures whether the value came from the suggested pick-list or was typed off-list (rudder-webapp)
 *
 * @param {AudienceSuggestionUsed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSuggestionUsed(
  props: AudienceSuggestionUsed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSuggestionUsed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Audience sync to a destination finishes (server-side)
 *
 * @param {AudienceSyncCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncCompleted(
  props: AudienceSyncCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User sets up a sync from an audience to a destination
 *
 * @param {AudienceSyncConfigured} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncConfigured(
  props: AudienceSyncConfigured,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncConfigured',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates a sync from an audience to a destination
 *
 * @param {AudienceSyncCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncCreated(
  props: AudienceSyncCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User deletes an audience sync
 *
 * @param {AudienceSyncDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncDeleted(
  props: AudienceSyncDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User opens an audience sync detail page
 *
 * @param {AudienceSyncDetailViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncDetailViewed(
  props: AudienceSyncDetailViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncDetailViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User edits the configuration of an audience sync
 *
 * @param {AudienceSyncEdited} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncEdited(
  props: AudienceSyncEdited,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncEdited',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * RETL sync job starts for a Data Graph audience — paired with audienceSyncCompleted on finish (server-side, from config-backend)
 *
 * @param {AudienceSyncExecuted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncExecuted(
  props: AudienceSyncExecuted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncExecuted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User enables or disables an audience sync
 *
 * @param {AudienceSyncToggled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function audienceSyncToggled(
  props: AudienceSyncToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'audienceSyncToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User changes bot blocking mode at workspace or source level
 *
 * @param {BotBlockingConfigured} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function botBlockingConfigured(
  props: BotBlockingConfigured,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'botBlockingConfigured',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User enables or disables AI bot detection
 *
 * @param {BotDetectionToggled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function botDetectionToggled(
  props: BotDetectionToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'botDetectionToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New event definition added to the data catalog
 *
 * @param {CatalogEventCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogEventCreated(
  props: CatalogEventCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogEventCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Event definition removed from the data catalog
 *
 * @param {CatalogEventDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogEventDeleted(
  props: CatalogEventDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogEventDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New property definition added to the data catalog
 *
 * @param {CatalogPropertyCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogPropertyCreated(
  props: CatalogPropertyCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogPropertyCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Property definition removed from the data catalog
 *
 * @param {CatalogPropertyDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function catalogPropertyDeleted(
  props: CatalogPropertyDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'catalogPropertyDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User opened checkout but navigated away without completing payment
 *
 * @param {CheckoutAbandoned} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function checkoutAbandoned(
  props: CheckoutAbandoned,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'checkoutAbandoned',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Payment confirmed and subscription active (client + server-side)
 *
 * @param {CheckoutCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function checkoutCompleted(
  props: CheckoutCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'checkoutCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Payment or checkout error including Stripe decline, 3DS failure, or network error
 *
 * @param {CheckoutError} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function checkoutError(
  props: CheckoutError,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'checkoutError',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Subscription drawer opens with payment form visible
 *
 * @param {CheckoutStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function checkoutStarted(
  props: CheckoutStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'checkoutStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes a step in the checkout flow
 *
 * @param {CheckoutStepCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function checkoutStepCompleted(
  props: CheckoutStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'checkoutStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A user clicks an interactive element. One generic event fired across the funnel; props describe what was clicked, where, and the object context. Replaces dozens of bespoke named click events.
 *
 * @param {Click} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function click(
  props: Click,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track('click', props || {}, withRudderTyperContext(options), callback)
  }
}
/**
 * User re-upgrades to a paid plan and reactivates previously preserved configs (server-side)
 *
 * @param {ConfigReactivated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function configReactivated(
  props: ConfigReactivated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'configReactivated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A source is successfully linked to a destination — the core value event
 *
 * @param {ConnectionCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function connectionCreated(
  props: ConnectionCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'connectionCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A source is unlinked from a destination
 *
 * @param {ConnectionRemoved} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function connectionRemoved(
  props: ConnectionRemoved,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'connectionRemoved',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * An audience expression is hydrated to physical schema (server-side, from dataplane-gateway)
 *
 * @param {DataGraphAudienceHydrated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphAudienceHydrated(
  props: DataGraphAudienceHydrated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphAudienceHydrated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User saved column-metadata changes on a Data Graph model — display-name aliases, descriptions, PII masks, and value-suggestion toggles (rudder-webapp)
 *
 * @param {DataGraphColumnMetadataUpdated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphColumnMetadataUpdated(
  props: DataGraphColumnMetadataUpdated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphColumnMetadataUpdated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A high-cardinality string column's value-suggestions were skipped and the in-builder skip notice was shown (rudder-webapp)
 *
 * @param {DataGraphColumnSuggestionsSkipped} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphColumnSuggestionsSkipped(
  props: DataGraphColumnSuggestionsSkipped,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphColumnSuggestionsSkipped',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates a Data Graph from a warehouse account
 *
 * @param {DataGraphCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphCreated(
  props: DataGraphCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User deletes a Data Graph
 *
 * @param {DataGraphDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphDeleted(
  props: DataGraphDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates a model (entity or event) in the Data Graph
 *
 * @param {DataGraphModelCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphModelCreated(
  props: DataGraphModelCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphModelCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User deletes a Data Graph model
 *
 * @param {DataGraphModelDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphModelDeleted(
  props: DataGraphModelDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphModelDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User updates configuration of a Data Graph model
 *
 * @param {DataGraphModelUpdated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphModelUpdated(
  props: DataGraphModelUpdated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphModelUpdated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates a relationship between models in the Data Graph
 *
 * @param {DataGraphRelationshipCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphRelationshipCreated(
  props: DataGraphRelationshipCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphRelationshipCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User deletes a relationship in the Data Graph
 *
 * @param {DataGraphRelationshipDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphRelationshipDeleted(
  props: DataGraphRelationshipDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphRelationshipDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User navigates to the Data Graph page
 *
 * @param {DataGraphViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function dataGraphViewed(
  props: DataGraphViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'dataGraphViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Destination successfully saved after setup
 *
 * @param {DestinationCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationCreated(
  props: DestinationCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User confirms destination deletion
 *
 * @param {DestinationDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationDeleted(
  props: DestinationDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User disables a destination
 *
 * @param {DestinationDisabled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationDisabled(
  props: DestinationDisabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationDisabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User re-enables a disabled destination
 *
 * @param {DestinationEnabled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationEnabled(
  props: DestinationEnabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationEnabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User selects a destination type to begin creation
 *
 * @param {DestinationSetupStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationSetupStarted(
  props: DestinationSetupStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationSetupStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes a step in the destination creation flow
 *
 * @param {DestinationSetupStepCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function destinationSetupStepCompleted(
  props: DestinationSetupStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'destinationSetupStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User searches for an integration in the directory
 *
 * @param {DirectorySearched} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function directorySearched(
  props: DirectorySearched,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'directorySearched',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User navigates to the integration directory
 *
 * @param {DirectoryViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function directoryViewed(
  props: DirectoryViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'directoryViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User adds an event to the block list
 *
 * @param {EventBlockingRuleCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function eventBlockingRuleCreated(
  props: EventBlockingRuleCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'eventBlockingRuleCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User removes an event from the block list
 *
 * @param {EventBlockingRuleRemoved} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function eventBlockingRuleRemoved(
  props: EventBlockingRuleRemoved,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'eventBlockingRuleRemoved',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User enables or disables the event blocking feature globally
 *
 * @param {EventBlockingToggled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function eventBlockingToggled(
  props: EventBlockingToggled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'eventBlockingToggled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User attempts to access a feature gated on their current plan
 *
 * @param {FeatureGateEncountered} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function featureGateEncountered(
  props: FeatureGateEncountered,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'featureGateEncountered',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * All getting started checklist items completed (activation proxy)
 *
 * @param {GettingStartedCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function gettingStartedCompleted(
  props: GettingStartedCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'gettingStartedCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes an individual item in the getting started checklist
 *
 * @param {GettingStartedStepCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function gettingStartedStepCompleted(
  props: GettingStartedStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'gettingStartedStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User navigates to the Health Dashboard
 *
 * @param {HealthDashboardViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function healthDashboardViewed(
  props: HealthDashboardViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'healthDashboardViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User clicks into a specific resource detail view from the Health Dashboard
 *
 * @param {HealthResourceInspected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function healthResourceInspected(
  props: HealthResourceInspected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'healthResourceInspected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User requests a new integration that does not exist
 *
 * @param {IntegrationRequested} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function integrationRequested(
  props: IntegrationRequested,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'integrationRequested',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User opens the live event stream for a source, destination, or transformation
 *
 * @param {LiveEventsViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function liveEventsViewed(
  props: LiveEventsViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'liveEventsViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * SQL model saved successfully
 *
 * @param {ModelCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function modelCreated(
  props: ModelCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'modelCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User confirms model deletion
 *
 * @param {ModelDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function modelDeleted(
  props: ModelDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'modelDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes a step in the post-signup account setup questionnaire
 *
 * @param {OnboardingStepCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function onboardingStepCompleted(
  props: OnboardingStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'onboardingStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Monthly overage invoice generated for events exceeding the selected volume tier (server-side)
 *
 * @param {OverageInvoiceGenerated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function overageInvoiceGenerated(
  props: OverageInvoiceGenerated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'overageInvoiceGenerated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A paid invoice payment failed via Stripe — the abandonment/retry signal (server-side)
 *
 * @param {PaymentFailed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function paymentFailed(
  props: PaymentFailed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'paymentFailed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * A paid invoice payment succeeded via Stripe (server-side)
 *
 * @param {PaymentSucceeded} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function paymentSucceeded(
  props: PaymentSucceeded,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'paymentSucceeded',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * The very first successful event delivery to a destination via a connection (one-time milestone per connection)
 *
 * @param {PipelineFirstDeliveryCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function pipelineFirstDeliveryCompleted(
  props: PipelineFirstDeliveryCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'pipelineFirstDeliveryCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * The very first event ever received by a source in this workspace (one-time milestone per source)
 *
 * @param {PipelineFirstEventReceived} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function pipelineFirstEventReceived(
  props: PipelineFirstEventReceived,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'pipelineFirstEventReceived',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Credential/connection validation finished during source or destination setup (passed, failed, or skipped) — captures why setups are abandoned
 *
 * @param {PipelineValidationCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function pipelineValidationCompleted(
  props: PipelineValidationCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'pipelineValidationCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Organization plan is upgraded, downgraded, or trial status changes (server-side)
 *
 * @param {PlanChanged} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function planChanged(
  props: PlanChanged,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'planChanged',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Usage reaches a warning threshold (80%, 90%, 95% of plan allocation)
 *
 * @param {PlanLimitApproached} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function planLimitApproached(
  props: PlanLimitApproached,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'planLimitApproached',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User hits a hard plan limit and action is blocked or degraded
 *
 * @param {PlanLimitReached} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function planLimitReached(
  props: PlanLimitReached,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'planLimitReached',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User selects a specific volume tier and billing cycle in the subscription drawer
 *
 * @param {PlanSelected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function planSelected(
  props: PlanSelected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'planSelected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User navigates to the Plans page with 3-tier pricing view
 *
 * @param {PricingPageViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function pricingPageViewed(
  props: PricingPageViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'pricingPageViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User views run artifacts and results for a Profiles project
 *
 * @param {ProfilesArtifactsViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesArtifactsViewed(
  props: ProfilesArtifactsViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesArtifactsViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User successfully converts an existing IDE-managed Profiles project to a Git-managed one
 *
 * @param {ProfilesProjectConverted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesProjectConverted(
  props: ProfilesProjectConverted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesProjectConverted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Profiles project successfully saved
 *
 * @param {ProfilesProjectCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesProjectCreated(
  props: ProfilesProjectCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesProjectCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User picks a creation flow (IDE, Git import, or Copilot) on the new Profiles project setup screen — funnel start for project creation
 *
 * @param {ProfilesProjectCreationStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesProjectCreationStarted(
  props: ProfilesProjectCreationStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesProjectCreationStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Profiles run finishes with success or failure (server-side)
 *
 * @param {ProfilesRunCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesRunCompleted(
  props: ProfilesRunCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesRunCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User triggers a profiles project run
 *
 * @param {ProfilesRunStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function profilesRunStarted(
  props: ProfilesRunStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'profilesRunStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User tries to create a resource but hits the plan count limit
 *
 * @param {ResourceLimitReached} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function resourceLimitReached(
  props: ResourceLimitReached,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'resourceLimitReached',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Reverse ETL source configured with warehouse data exposed as event source
 *
 * @param {RetlSourceCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function retlSourceCreated(
  props: RetlSourceCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'retlSourceCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Reverse ETL sync job finishes (server-side)
 *
 * @param {RetlSyncCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function retlSyncCompleted(
  props: RetlSyncCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'retlSyncCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User manually triggers a Reverse ETL sync
 *
 * @param {RetlSyncTriggered} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function retlSyncTriggered(
  props: RetlSyncTriggered,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'retlSyncTriggered',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User generates a new service access token
 *
 * @param {ServiceTokenCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function serviceTokenCreated(
  props: ServiceTokenCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'serviceTokenCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Source successfully saved after setup
 *
 * @param {SourceCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceCreated(
  props: SourceCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User confirms source deletion
 *
 * @param {SourceDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceDeleted(
  props: SourceDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User toggles a source off
 *
 * @param {SourceDisabled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceDisabled(
  props: SourceDisabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceDisabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User toggles a disabled source back on
 *
 * @param {SourceEnabled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceEnabled(
  props: SourceEnabled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceEnabled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User selects an integration from the directory to begin source creation
 *
 * @param {SourceSetupStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceSetupStarted(
  props: SourceSetupStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceSetupStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes a step in the multi-step source creation flow
 *
 * @param {SourceSetupStepCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function sourceSetupStepCompleted(
  props: SourceSetupStepCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'sourceSetupStepCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User confirms subscription cancellation, access continues through cycle end (server-side)
 *
 * @param {SubscriptionCancelled} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function subscriptionCancelled(
  props: SubscriptionCancelled,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'subscriptionCancelled',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Subscription auto-renews at period end (server-side)
 *
 * @param {SubscriptionRenewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function subscriptionRenewed(
  props: SubscriptionRenewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'subscriptionRenewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User manually retries a failed sync or delivery
 *
 * @param {SyncRetryTriggered} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function syncRetryTriggered(
  props: SyncRetryTriggered,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'syncRetryTriggered',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User sends an invitation to a new team member
 *
 * @param {TeamMemberInvited} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function teamMemberInvited(
  props: TeamMemberInvited,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'teamMemberInvited',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User changes another member's role
 *
 * @param {TeamMemberRoleChanged} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function teamMemberRoleChanged(
  props: TeamMemberRoleChanged,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'teamMemberRoleChanged',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Tracking plan linked to a source for validation
 *
 * @param {TrackingPlanConnected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanConnected(
  props: TrackingPlanConnected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanConnected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New tracking plan saved
 *
 * @param {TrackingPlanCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanCreated(
  props: TrackingPlanCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Tracking plan unlinked from a source
 *
 * @param {TrackingPlanDisconnected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanDisconnected(
  props: TrackingPlanDisconnected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanDisconnected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Events or properties modified in a tracking plan
 *
 * @param {TrackingPlanEdited} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanEdited(
  props: TrackingPlanEdited,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanEdited',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * An incoming event violates a tracking plan rule (server-side, sampled)
 *
 * @param {TrackingPlanViolationDetected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trackingPlanViolationDetected(
  props: TrackingPlanViolationDetected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trackingPlanViolationDetected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Transformation linked to a destination
 *
 * @param {TransformationConnected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationConnected(
  props: TransformationConnected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationConnected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New transformation saved successfully
 *
 * @param {TransformationCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationCreated(
  props: TransformationCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User confirms transformation deletion
 *
 * @param {TransformationDeleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationDeleted(
  props: TransformationDeleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationDeleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Transformation unlinked from a destination
 *
 * @param {TransformationDisconnected} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationDisconnected(
  props: TransformationDisconnected,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationDisconnected',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Reusable transformation library saved
 *
 * @param {TransformationLibraryCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationLibraryCreated(
  props: TransformationLibraryCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationLibraryCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User publishes a draft transformation (V2 draft mode)
 *
 * @param {TransformationPublished} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationPublished(
  props: TransformationPublished,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationPublished',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User runs test on a transformation
 *
 * @param {TransformationTested} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function transformationTested(
  props: TransformationTested,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'transformationTested',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Trial reaches a successful terminal state / converts (server-side)
 *
 * @param {TrialCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialCompleted(
  props: TrialCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Grace period ends and features revert to Free tier limits (server-side)
 *
 * @param {TrialExpired} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialExpired(
  props: TrialExpired,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialExpired',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Internal admin extends a trial (server-side)
 *
 * @param {TrialExtended} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialExtended(
  props: TrialExtended,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialExtended',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Trial end date passes without conversion, user enters 7-day grace period (server-side)
 *
 * @param {TrialGracePeriodStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialGracePeriodStarted(
  props: TrialGracePeriodStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialGracePeriodStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User completes the Day 31 migration wizard selecting which resources to keep
 *
 * @param {TrialMigrationWizardCompleted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialMigrationWizardCompleted(
  props: TrialMigrationWizardCompleted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialMigrationWizardCompleted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Trial provisioned for an organization (server-side)
 *
 * @param {TrialStarted} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialStarted(
  props: TrialStarted,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialStarted',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * In-app trial expiry warning is shown to the user
 *
 * @param {TrialWarningShown} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function trialWarningShown(
  props: TrialWarningShown,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'trialWarningShown',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User clicks any upgrade CTA
 *
 * @param {UpgradeCtaClicked} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function upgradeCtaClicked(
  props: UpgradeCtaClicked,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'upgradeCtaClicked',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * An upgrade CTA is rendered and visible to the user (once per location per session)
 *
 * @param {UpgradeCtaViewed} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function upgradeCtaViewed(
  props: UpgradeCtaViewed,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'upgradeCtaViewed',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User finishes or skips through the entire onboarding questionnaire
 *
 * @param {UserCompletedOnboarding} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function userCompletedOnboarding(
  props: UserCompletedOnboarding,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'userCompletedOnboarding',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * Successful authentication via any method
 *
 * @param {UserLoggedIn} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function userLoggedIn(
  props: UserLoggedIn,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'userLoggedIn',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * New user record created via initial signup or invite acceptance (server-side)
 *
 * @param {UserSignedUp} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function userSignedUp(
  props: UserSignedUp,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'userSignedUp',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User creates a new workspace within their organization
 *
 * @param {WorkspaceCreated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function workspaceCreated(
  props: WorkspaceCreated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'workspaceCreated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User changes workspace-level settings
 *
 * @param {WorkspaceSettingsUpdated} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function workspaceSettingsUpdated(
  props: WorkspaceSettingsUpdated,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'workspaceSettingsUpdated',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}
/**
 * User switches active workspace
 *
 * @param {WorkspaceSwitched} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function workspaceSwitched(
  props: WorkspaceSwitched,
  options?: ApiOptions,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    a.track(
      'workspaceSwitched',
      props || {},
      withRudderTyperContext(options),
      callback
    )
  }
}

/**
 * Tracks page views on every client-side route change via React Router. Uses a route-to-metadata map to derive name and category.
 *
 * @param {string} [category] - The category of the page.
 * @param {string} [name] - The name of the page.
 * @param {Page} props - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function page(
  category: string,
  name: string,
  props: Page,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function page(
  name: string,
  props: Page,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function page(
  props: Page,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function page(
  categoryOrProps?: string | Page,
  nameOrPropsOrOptions?: string | Page | ApiOptions,
  propsOrOptionsOrCallback?: Page | ApiOptions | apiCallback,
  optionsOrCallback?: ApiOptions | apiCallback,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    if (
      typeof categoryOrProps === 'string' &&
      typeof nameOrPropsOrOptions === 'string'
    ) {
      // Overload (category: string, name: string, props?: Page, options?: ApiOptions, callback?: apiCallback)
      a.page(
        categoryOrProps,
        'page',
        (propsOrOptionsOrCallback as Page) || {},
        withRudderTyperContext(optionsOrCallback as ApiOptions),
        callback
      )
    } else if (typeof categoryOrProps === 'string') {
      // Overload (name: string, props?: Page, options?: ApiOptions, callback?: apiCallback)
      a.page(
        'page',
        (nameOrPropsOrOptions as Page) || {},
        withRudderTyperContext(propsOrOptionsOrCallback as ApiOptions),
        optionsOrCallback as apiCallback
      )
    } else {
      // Overload (props?: Page, options?: ApiOptions, callback?: apiCallback)
      a.page(
        categoryOrProps || {},
        withRudderTyperContext(nameOrPropsOrOptions as ApiOptions),
        propsOrOptionsOrCallback as apiCallback
      )
    }
  }
}

/**
 * Establishes user identity and traits. Called on every login, workspace switch, and onboarding completion.
 *
 * @param {string} [userId] - The user ID of the user.
 * @param {Identify} [traits] - The analytics traits that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function identify(
  userId: string,
  traits?: Identify,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function identify(
  traits?: Identify,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function identify(
  userIdOrTraits?: string | Identify,
  traitsOrOptions?: Identify | ApiOptions,
  optionsOrCallback?: ApiOptions | apiCallback,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    const userId =
      typeof userIdOrTraits === 'string' ? userIdOrTraits : undefined
    const traits =
      typeof userIdOrTraits === 'string'
        ? (traitsOrOptions as Identify)
        : (userIdOrTraits as Identify)
    const options =
      typeof userIdOrTraits === 'string'
        ? (optionsOrCallback as ApiOptions)
        : (traitsOrOptions as ApiOptions)
    const cb =
      typeof userIdOrTraits === 'string'
        ? callback
        : (optionsOrCallback as apiCallback)

    a.identify(userId, traits || {}, withRudderTyperContext(options), cb)
  }
}

/**
 * Associates user with their organization. Called on login, workspace switch, and first connection created.
 *
 * @param {string} [groupId] - The group ID of the group.
 * @param {Group} [traits] - The analytics traits that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
 */
export function group(
  groupId: string,
  traits?: Group,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function group(
  traits?: Group,
  options?: ApiOptions,
  callback?: apiCallback
): void
export function group(
  groupIdOrTraits?: string | Group,
  traitsOrOptions?: Group | ApiOptions,
  optionsOrCallback?: ApiOptions | apiCallback,
  callback?: apiCallback
): void {
  const a = analytics()

  if (a) {
    if (typeof groupIdOrTraits === 'string') {
      const groupId = groupIdOrTraits
      const traits = (traitsOrOptions as Group) || {}
      const options = optionsOrCallback as ApiOptions
      a.group(groupId, traits, withRudderTyperContext(options), callback)
    } else {
      const traits = (groupIdOrTraits as Group) || {}
      const options = traitsOrOptions as ApiOptions
      const cb = optionsOrCallback as apiCallback
      a.group(traits, withRudderTyperContext(options), cb)
    }
  }
}

const clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions,
  /**
   * New organization record provisioned in the system (server-side)
   *
   * @param {AccountCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  accountCreated,
  /**
   * User creates or modifies an alert rule
   *
   * @param {AlertConfigured} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  alertConfigured,
  /**
   * User enables or disables a specific alert
   *
   * @param {AlertToggled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  alertToggled,
  /**
   * New audience saved (Data Graph Audiences or Cohort Audiences)
   *
   * @param {AudienceCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceCreated,
  /**
   * User deletes an audience
   *
   * @param {AudienceDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceDeleted,
  /**
   * User opens an audience detail page
   *
   * @param {AudienceDetailViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceDetailViewed,
  /**
   * User modifies an audience expression in the builder
   *
   * @param {AudienceExpressionEdited} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceExpressionEdited,
  /**
   * User opens the audience list page for a Data Graph
   *
   * @param {AudienceListViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceListViewed,
  /**
   * User triggers an audience preview
   *
   * @param {AudiencePreviewSubmitted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audiencePreviewSubmitted,
  /**
   * User renames an audience
   *
   * @param {AudienceRenamed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceRenamed,
  /**
   * User committed an audience condition value on a value-suggestion-bearing string column; captures whether the value came from the suggested pick-list or was typed off-list (rudder-webapp)
   *
   * @param {AudienceSuggestionUsed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSuggestionUsed,
  /**
   * Audience sync to a destination finishes (server-side)
   *
   * @param {AudienceSyncCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncCompleted,
  /**
   * User sets up a sync from an audience to a destination
   *
   * @param {AudienceSyncConfigured} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncConfigured,
  /**
   * User creates a sync from an audience to a destination
   *
   * @param {AudienceSyncCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncCreated,
  /**
   * User deletes an audience sync
   *
   * @param {AudienceSyncDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncDeleted,
  /**
   * User opens an audience sync detail page
   *
   * @param {AudienceSyncDetailViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncDetailViewed,
  /**
   * User edits the configuration of an audience sync
   *
   * @param {AudienceSyncEdited} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncEdited,
  /**
   * RETL sync job starts for a Data Graph audience — paired with audienceSyncCompleted on finish (server-side, from config-backend)
   *
   * @param {AudienceSyncExecuted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncExecuted,
  /**
   * User enables or disables an audience sync
   *
   * @param {AudienceSyncToggled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  audienceSyncToggled,
  /**
   * User changes bot blocking mode at workspace or source level
   *
   * @param {BotBlockingConfigured} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  botBlockingConfigured,
  /**
   * User enables or disables AI bot detection
   *
   * @param {BotDetectionToggled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  botDetectionToggled,
  /**
   * New event definition added to the data catalog
   *
   * @param {CatalogEventCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogEventCreated,
  /**
   * Event definition removed from the data catalog
   *
   * @param {CatalogEventDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogEventDeleted,
  /**
   * New property definition added to the data catalog
   *
   * @param {CatalogPropertyCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogPropertyCreated,
  /**
   * Property definition removed from the data catalog
   *
   * @param {CatalogPropertyDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  catalogPropertyDeleted,
  /**
   * User opened checkout but navigated away without completing payment
   *
   * @param {CheckoutAbandoned} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  checkoutAbandoned,
  /**
   * Payment confirmed and subscription active (client + server-side)
   *
   * @param {CheckoutCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  checkoutCompleted,
  /**
   * Payment or checkout error including Stripe decline, 3DS failure, or network error
   *
   * @param {CheckoutError} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  checkoutError,
  /**
   * Subscription drawer opens with payment form visible
   *
   * @param {CheckoutStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  checkoutStarted,
  /**
   * User completes a step in the checkout flow
   *
   * @param {CheckoutStepCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  checkoutStepCompleted,
  /**
   * A user clicks an interactive element. One generic event fired across the funnel; props describe what was clicked, where, and the object context. Replaces dozens of bespoke named click events.
   *
   * @param {Click} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  click,
  /**
   * User re-upgrades to a paid plan and reactivates previously preserved configs (server-side)
   *
   * @param {ConfigReactivated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  configReactivated,
  /**
   * A source is successfully linked to a destination — the core value event
   *
   * @param {ConnectionCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  connectionCreated,
  /**
   * A source is unlinked from a destination
   *
   * @param {ConnectionRemoved} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  connectionRemoved,
  /**
   * An audience expression is hydrated to physical schema (server-side, from dataplane-gateway)
   *
   * @param {DataGraphAudienceHydrated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphAudienceHydrated,
  /**
   * User saved column-metadata changes on a Data Graph model — display-name aliases, descriptions, PII masks, and value-suggestion toggles (rudder-webapp)
   *
   * @param {DataGraphColumnMetadataUpdated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphColumnMetadataUpdated,
  /**
   * A high-cardinality string column's value-suggestions were skipped and the in-builder skip notice was shown (rudder-webapp)
   *
   * @param {DataGraphColumnSuggestionsSkipped} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphColumnSuggestionsSkipped,
  /**
   * User creates a Data Graph from a warehouse account
   *
   * @param {DataGraphCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphCreated,
  /**
   * User deletes a Data Graph
   *
   * @param {DataGraphDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphDeleted,
  /**
   * User creates a model (entity or event) in the Data Graph
   *
   * @param {DataGraphModelCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphModelCreated,
  /**
   * User deletes a Data Graph model
   *
   * @param {DataGraphModelDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphModelDeleted,
  /**
   * User updates configuration of a Data Graph model
   *
   * @param {DataGraphModelUpdated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphModelUpdated,
  /**
   * User creates a relationship between models in the Data Graph
   *
   * @param {DataGraphRelationshipCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphRelationshipCreated,
  /**
   * User deletes a relationship in the Data Graph
   *
   * @param {DataGraphRelationshipDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphRelationshipDeleted,
  /**
   * User navigates to the Data Graph page
   *
   * @param {DataGraphViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  dataGraphViewed,
  /**
   * Destination successfully saved after setup
   *
   * @param {DestinationCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationCreated,
  /**
   * User confirms destination deletion
   *
   * @param {DestinationDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationDeleted,
  /**
   * User disables a destination
   *
   * @param {DestinationDisabled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationDisabled,
  /**
   * User re-enables a disabled destination
   *
   * @param {DestinationEnabled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationEnabled,
  /**
   * User selects a destination type to begin creation
   *
   * @param {DestinationSetupStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationSetupStarted,
  /**
   * User completes a step in the destination creation flow
   *
   * @param {DestinationSetupStepCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  destinationSetupStepCompleted,
  /**
   * User searches for an integration in the directory
   *
   * @param {DirectorySearched} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  directorySearched,
  /**
   * User navigates to the integration directory
   *
   * @param {DirectoryViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  directoryViewed,
  /**
   * User adds an event to the block list
   *
   * @param {EventBlockingRuleCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  eventBlockingRuleCreated,
  /**
   * User removes an event from the block list
   *
   * @param {EventBlockingRuleRemoved} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  eventBlockingRuleRemoved,
  /**
   * User enables or disables the event blocking feature globally
   *
   * @param {EventBlockingToggled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  eventBlockingToggled,
  /**
   * User attempts to access a feature gated on their current plan
   *
   * @param {FeatureGateEncountered} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  featureGateEncountered,
  /**
   * All getting started checklist items completed (activation proxy)
   *
   * @param {GettingStartedCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  gettingStartedCompleted,
  /**
   * User completes an individual item in the getting started checklist
   *
   * @param {GettingStartedStepCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  gettingStartedStepCompleted,
  /**
   * User navigates to the Health Dashboard
   *
   * @param {HealthDashboardViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  healthDashboardViewed,
  /**
   * User clicks into a specific resource detail view from the Health Dashboard
   *
   * @param {HealthResourceInspected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  healthResourceInspected,
  /**
   * User requests a new integration that does not exist
   *
   * @param {IntegrationRequested} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  integrationRequested,
  /**
   * User opens the live event stream for a source, destination, or transformation
   *
   * @param {LiveEventsViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  liveEventsViewed,
  /**
   * SQL model saved successfully
   *
   * @param {ModelCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  modelCreated,
  /**
   * User confirms model deletion
   *
   * @param {ModelDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  modelDeleted,
  /**
   * User completes a step in the post-signup account setup questionnaire
   *
   * @param {OnboardingStepCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  onboardingStepCompleted,
  /**
   * Monthly overage invoice generated for events exceeding the selected volume tier (server-side)
   *
   * @param {OverageInvoiceGenerated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  overageInvoiceGenerated,
  /**
   * A paid invoice payment failed via Stripe — the abandonment/retry signal (server-side)
   *
   * @param {PaymentFailed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  paymentFailed,
  /**
   * A paid invoice payment succeeded via Stripe (server-side)
   *
   * @param {PaymentSucceeded} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  paymentSucceeded,
  /**
   * The very first successful event delivery to a destination via a connection (one-time milestone per connection)
   *
   * @param {PipelineFirstDeliveryCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  pipelineFirstDeliveryCompleted,
  /**
   * The very first event ever received by a source in this workspace (one-time milestone per source)
   *
   * @param {PipelineFirstEventReceived} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  pipelineFirstEventReceived,
  /**
   * Credential/connection validation finished during source or destination setup (passed, failed, or skipped) — captures why setups are abandoned
   *
   * @param {PipelineValidationCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  pipelineValidationCompleted,
  /**
   * Organization plan is upgraded, downgraded, or trial status changes (server-side)
   *
   * @param {PlanChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  planChanged,
  /**
   * Usage reaches a warning threshold (80%, 90%, 95% of plan allocation)
   *
   * @param {PlanLimitApproached} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  planLimitApproached,
  /**
   * User hits a hard plan limit and action is blocked or degraded
   *
   * @param {PlanLimitReached} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  planLimitReached,
  /**
   * User selects a specific volume tier and billing cycle in the subscription drawer
   *
   * @param {PlanSelected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  planSelected,
  /**
   * User navigates to the Plans page with 3-tier pricing view
   *
   * @param {PricingPageViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  pricingPageViewed,
  /**
   * User views run artifacts and results for a Profiles project
   *
   * @param {ProfilesArtifactsViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesArtifactsViewed,
  /**
   * User successfully converts an existing IDE-managed Profiles project to a Git-managed one
   *
   * @param {ProfilesProjectConverted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesProjectConverted,
  /**
   * Profiles project successfully saved
   *
   * @param {ProfilesProjectCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesProjectCreated,
  /**
   * User picks a creation flow (IDE, Git import, or Copilot) on the new Profiles project setup screen — funnel start for project creation
   *
   * @param {ProfilesProjectCreationStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesProjectCreationStarted,
  /**
   * Profiles run finishes with success or failure (server-side)
   *
   * @param {ProfilesRunCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesRunCompleted,
  /**
   * User triggers a profiles project run
   *
   * @param {ProfilesRunStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  profilesRunStarted,
  /**
   * User tries to create a resource but hits the plan count limit
   *
   * @param {ResourceLimitReached} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  resourceLimitReached,
  /**
   * Reverse ETL source configured with warehouse data exposed as event source
   *
   * @param {RetlSourceCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  retlSourceCreated,
  /**
   * Reverse ETL sync job finishes (server-side)
   *
   * @param {RetlSyncCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  retlSyncCompleted,
  /**
   * User manually triggers a Reverse ETL sync
   *
   * @param {RetlSyncTriggered} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  retlSyncTriggered,
  /**
   * User generates a new service access token
   *
   * @param {ServiceTokenCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  serviceTokenCreated,
  /**
   * Source successfully saved after setup
   *
   * @param {SourceCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceCreated,
  /**
   * User confirms source deletion
   *
   * @param {SourceDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceDeleted,
  /**
   * User toggles a source off
   *
   * @param {SourceDisabled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceDisabled,
  /**
   * User toggles a disabled source back on
   *
   * @param {SourceEnabled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceEnabled,
  /**
   * User selects an integration from the directory to begin source creation
   *
   * @param {SourceSetupStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceSetupStarted,
  /**
   * User completes a step in the multi-step source creation flow
   *
   * @param {SourceSetupStepCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  sourceSetupStepCompleted,
  /**
   * User confirms subscription cancellation, access continues through cycle end (server-side)
   *
   * @param {SubscriptionCancelled} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  subscriptionCancelled,
  /**
   * Subscription auto-renews at period end (server-side)
   *
   * @param {SubscriptionRenewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  subscriptionRenewed,
  /**
   * User manually retries a failed sync or delivery
   *
   * @param {SyncRetryTriggered} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  syncRetryTriggered,
  /**
   * User sends an invitation to a new team member
   *
   * @param {TeamMemberInvited} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  teamMemberInvited,
  /**
   * User changes another member's role
   *
   * @param {TeamMemberRoleChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  teamMemberRoleChanged,
  /**
   * Tracking plan linked to a source for validation
   *
   * @param {TrackingPlanConnected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanConnected,
  /**
   * New tracking plan saved
   *
   * @param {TrackingPlanCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanCreated,
  /**
   * Tracking plan unlinked from a source
   *
   * @param {TrackingPlanDisconnected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanDisconnected,
  /**
   * Events or properties modified in a tracking plan
   *
   * @param {TrackingPlanEdited} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanEdited,
  /**
   * An incoming event violates a tracking plan rule (server-side, sampled)
   *
   * @param {TrackingPlanViolationDetected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trackingPlanViolationDetected,
  /**
   * Transformation linked to a destination
   *
   * @param {TransformationConnected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationConnected,
  /**
   * New transformation saved successfully
   *
   * @param {TransformationCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationCreated,
  /**
   * User confirms transformation deletion
   *
   * @param {TransformationDeleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationDeleted,
  /**
   * Transformation unlinked from a destination
   *
   * @param {TransformationDisconnected} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationDisconnected,
  /**
   * Reusable transformation library saved
   *
   * @param {TransformationLibraryCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationLibraryCreated,
  /**
   * User publishes a draft transformation (V2 draft mode)
   *
   * @param {TransformationPublished} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationPublished,
  /**
   * User runs test on a transformation
   *
   * @param {TransformationTested} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  transformationTested,
  /**
   * Trial reaches a successful terminal state / converts (server-side)
   *
   * @param {TrialCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialCompleted,
  /**
   * Grace period ends and features revert to Free tier limits (server-side)
   *
   * @param {TrialExpired} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialExpired,
  /**
   * Internal admin extends a trial (server-side)
   *
   * @param {TrialExtended} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialExtended,
  /**
   * Trial end date passes without conversion, user enters 7-day grace period (server-side)
   *
   * @param {TrialGracePeriodStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialGracePeriodStarted,
  /**
   * User completes the Day 31 migration wizard selecting which resources to keep
   *
   * @param {TrialMigrationWizardCompleted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialMigrationWizardCompleted,
  /**
   * Trial provisioned for an organization (server-side)
   *
   * @param {TrialStarted} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialStarted,
  /**
   * In-app trial expiry warning is shown to the user
   *
   * @param {TrialWarningShown} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  trialWarningShown,
  /**
   * User clicks any upgrade CTA
   *
   * @param {UpgradeCtaClicked} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  upgradeCtaClicked,
  /**
   * An upgrade CTA is rendered and visible to the user (once per location per session)
   *
   * @param {UpgradeCtaViewed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  upgradeCtaViewed,
  /**
   * User finishes or skips through the entire onboarding questionnaire
   *
   * @param {UserCompletedOnboarding} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  userCompletedOnboarding,
  /**
   * Successful authentication via any method
   *
   * @param {UserLoggedIn} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  userLoggedIn,
  /**
   * New user record created via initial signup or invite acceptance (server-side)
   *
   * @param {UserSignedUp} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  userSignedUp,
  /**
   * User creates a new workspace within their organization
   *
   * @param {WorkspaceCreated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  workspaceCreated,
  /**
   * User changes workspace-level settings
   *
   * @param {WorkspaceSettingsUpdated} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  workspaceSettingsUpdated,
  /**
   * User switches active workspace
   *
   * @param {WorkspaceSwitched} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  workspaceSwitched,
  /**
   * Tracks page views on every client-side route change via React Router. Uses a route-to-metadata map to derive name and category.
   *
   * @param {string} [category] - The category of the page.
   * @param {string} [name] - The name of the page.
   * @param {Page} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  page,
  /**
   * Establishes user identity and traits. Called on every login, workspace switch, and onboarding completion.
   *
   * @param {string} [userId] - The user ID of the user.
   * @param {Identify} [traits] - The analytics traits that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  identify,
  /**
   * Associates user with their organization. Called on login, workspace switch, and first connection created.
   *
   * @param {string} [groupId] - The group ID of the group.
   * @param {Group} [traits] - The analytics traits that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics call is fired.
   */
  group,
}

export const RudderTyperAnalytics = new Proxy<typeof clientAPI>(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && Object.keys(target).includes(method)) {
      return target[method as keyof typeof clientAPI]
    }

    return () => {
      const a = analytics()
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withRudderTyperContext()
        )
      }
    }
  },
})
